import React, { useEffect } from 'react'
import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"


const SecureRouterWrapper = props => {

    const { pathname } = useLocation()
    // const MyPath = useLocation()

    const navigate = useNavigate()

    const isAuth = useSelector(({ auth }) => auth.isAuth)

    // console.log({isAuth,pathname,},MyPath.location?.pathname)
    useEffect(() => {
    // console.log({isAuth,pathname,},MyPath.location?.pathname,"inside")

        if (!isAuth && pathname == "/room") {
            navigate("/")
        }
        if (isAuth && pathname == "/") {
            navigate("/room")
        }
    }, [isAuth, pathname])

    return (
        <>
            {props.children}
        </>
    )
}



export default SecureRouterWrapper
